import React from 'react';
import Button from '../../../utils/components/Button/Button';
import { renderPost } from '../../Post/MasoryPostCard/utils';

import style from "./Campaigns.module.css"
const Campaigns = ({ post, formik }) => {
    if (!post?._id) {
        return <div>Cargando</div>
    }
    return (
        <div className={style.campaigns_container}>
            <div className={style.campaigns_post}>

                {true &&
                    <div className="content-img-post-templete scroll-menu">
                        {renderPost(post)}
                    </div>
                }
            </div>
            <div className={style.campaigns_form_container}>
                <div className={style.campaigns_title}>Definir puntos de ranking y Ecos por</div>
                <div className={style.campaigns_input_container_row}>
                    <div className={style.campaigns_input_container_cell}>
                        <div className={style.campaigns_input_container}>
                            Reaccionar
                            <input type='number' placeholder='puntos' value={formik.values.likePoints} name='likePoints' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                            <input type='number' placeholder='Ecos' value={formik.values.likeEcos} name='likeEcos' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                        </div>
                        <div className={style.campaigns_input_errors}>{formik.errors.likePoints}</div>
                    </div>

                    <div className={style.campaigns_input_container_cell}>
                        <div className={style.campaigns_input_container}>
                            Cantidad total a repartir
                            <input type='number' value={formik.values.likePointsTotalPoints} name='likePointsTotalPoints' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                        </div>
                        <div className={style.campaigns_input_errors}>{formik.errors.likePointsTotalPoints}</div>
                    </div>
                </div>

                <div className={style.campaigns_input_container_row}>
                    <div className={style.campaigns_input_container_cell}>
                        <div className={style.campaigns_input_container}>
                            Comentar
                            <input type='number' value={formik.values.commentPoints} name='commentPoints' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                            <input type='number' value={formik.values.commentEcos} name='commentEcos' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                        </div>
                        <div className={style.campaigns_input_errors}>{formik.errors.commentPoints}</div>
                    </div>

                    <div className={style.campaigns_input_container_cell}>
                        <div className={style.campaigns_input_container}>
                            Cantidad total a repartir
                            <input type='number' value={formik.values.commentPointsTotalPoints} name='commentPointsTotalPoints' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                        </div>
                        <div className={style.campaigns_input_errors}>{formik.errors.commentPointsTotalPoints}</div>
                    </div>
                </div>

                <div className={style.campaigns_input_container_row}>
                    <div className={style.campaigns_input_container_cell}>
                        <div className={style.campaigns_input_container}>
                            Compartir
                            <input type='number' value={formik.values.sharePoints} name='sharePoints' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                            <input type='number' value={formik.values.shareEcos} name='shareEcos' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                        </div>
                        <div className={style.campaigns_input_errors}>{formik.errors.sharePoints}</div>
                    </div>

                    <div className={style.campaigns_input_container_cell}>
                        <div className={style.campaigns_input_container}>
                            Cantidad total a repartir
                            <input type='number' value={formik.values.sharePointsTotalPoints} name='sharePointsTotalPoints' min={1} onChange={formik.handleChange} className={style.campaigns_input} />
                        </div>
                        <div className={style.campaigns_input_errors}>{formik.errors.sharePointsTotalPoints}</div>
                    </div>
                </div>





                {/* 
                <div>
                    <div className={style.campaigns_input_container}>
                        Reaccionar
                        <div>
                            <input type='number' value={formik.values.likePoints} name='likePoints' onChange={formik.handleChange} className={style.campaigns_input} />

                        </div>


                    </div>
                </div>

                <div>
                    <div>{formik.errors.likePoints}</div>
                </div>
                <div className={style.campaigns_input_container}>
                    Comentar
                    <div>
                        <input type='number' value={formik.values.commentPoints} name='commentPoints' onChange={formik.handleChange} className={style.campaigns_input} />
                        <div>{formik.errors.commentPoints}</div>
                    </div>
                    Cantidad total a repartir
                    <input type='number' value={formik.values.commentPointsTotalPoints} name='commentPointsTotalPoints' onChange={formik.handleChange} className={style.campaigns_input} />
                </div>
                <div className={style.campaigns_input_container}>
                    Compartir
                    <div>
                        <input type='number' value={formik.values.sharePoints} name='sharePoints' onChange={formik.handleChange} className={style.campaigns_input} />
                        <div>{formik.errors.sharePoints}</div>
                    </div>
                    Cantidad total a repartir
                    <input type='number' value={formik.values.sharePointsTotalPoints} name='sharePointsTotalPoints' onChange={formik.handleChange} className={style.campaigns_input} />
                </div>
 */}                <Button
                    onClick={formik.handleSubmit}
                    text='Guardar'
                />
            </div>
        </div>
    )
};

export default Campaigns;
